import React from "react";
import { statusMeta, PRIORITY } from "@/lib/statusColors";

export function StatusBadge({ status, dot = true, className = "" }) {
  if (!status) return null;
  const m = statusMeta(status);
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${m.badge} ${className}`}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: m.dot }} />}
      {status}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  if (!priority) return null;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${PRIORITY[priority] || PRIORITY.Normal}`}>
      {priority}
    </span>
  );
}
